<template>
    <div class="scc-image-element-container">
        <img class="scc-image-element" :class="{ 'scc-image-element--full-width': mobileSrc }" :src="src" :alt="alt" />
        <img v-if="mobileSrc" class="scc-image-element scc-image-element--mobile" :src="mobileSrc" :alt="alt" />
    </div>
</template>

<script>
import './image-element.scss';

export default {
    name: 'ImageElement',
    props: {
        src: {
            type: String,
            default: undefined,
        },
        mobileSrc: {
            type: String,
            default: undefined,
        },
        alt: {
            type: String,
            default: undefined,
        },
    },
};
</script>
